<div class="sonder-form-optin" fxFlexLayout="row" fxFlexLayoutGap="1em">
  <ng-content></ng-content>
  <ul class="sonder-form-errors">
    <li *ngFor="let error of errors">{{ error }}</li>
  </ul>
</div>